export const clientId = 'beab0930839f98ade6e9af78da0ed230';
